
import React, { ChangeEvent, ReactNode, useCallback } from 'react'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'

import { TextFieldProps } from '@mui/material/TextField'

type Option = {
  id: string,
  label: string | number
}

type Props = {
  options: Array<Option>,
  selectedOptionId: string,
  onValueChange: (arg0: string) => void,
  emptyMessage?: ReactNode,
  classes?: {
    [K in string]: string
  }
} & TextFieldProps

export default function DropdownMenu ({
  emptyMessage,
  options,
  selectedOptionId,
  onValueChange,
  classes,
  ...rest
}: Props) {
  const onUpdateValue = useCallback((e: ChangeEvent<HTMLInputElement>) => { onValueChange(e.target.value) }, [onValueChange])

  const isDisabled = options.length === 0 || (options.length === 1 && options[0].id === selectedOptionId)
  const hasOptions = options && options.length > 0

  const menuItems = hasOptions
    ? (
      options.map(option => (
        <MenuItem
          data-ht-category='dropdown'
          data-ht-action={`select ${option.label}`}
          data-ht-label={option.label}
          key={option.id}
          value={option.id}
          classes={{ selected: classes?.itemSelected }}
        >
          {option.label}
        </MenuItem>
      ))
    ) : (
      <MenuItem
        key={'empty'}
        value={'empty'}
      >
        {emptyMessage}
      </MenuItem>
    )

  return (
    <TextField
      select
      value={hasOptions ? selectedOptionId : 'empty'}
      onChange={onUpdateValue}
      disabled={isDisabled}
      {...rest}
    >
      {menuItems}
    </TextField>
  )
}
